import type { RouteRecordRaw } from "vue-router";

const Checkout = () => import("@/pages/checkout/innovadis/inno-checkout-index.vue");
const Completed = () => import("@/pages/checkout/innovadis/inno-completed.vue");
const Cancelled = () => import("@/pages/checkout/innovadis/inno-cancelled.vue");
const Overview = () => import("@/pages/checkout/innovadis/inno-overview.vue");
const Payment = () => import("@/pages/checkout/payment.vue");

export const customCheckoutRoutes: RouteRecordRaw[] = [
  {
    path: "/checkout/completed",
    name: "CheckoutCompleted",
    component: Completed,
  },
  {
    path: "/checkout/cancelled",
    name: "CheckoutCancelled",
    component: Cancelled,
  },
  {
    path: "/checkout",
    name: "Checkout",
    component: Checkout,
    children: [
      {
        path: "overview",
        name: "Overview",
        component: Overview,
      },
      {
        path: "payment",
        name: "CheckoutPayment",
        component: Payment,
      },
    ],
    meta: { layout: "Secure" },
    beforeEnter(to, from, next) {
      if (from.name === "Cart") {
        next();
      } else if (from.name === "CheckoutPaymentResult" && to.name === "CheckoutPayment") {
        next();
      } else {
        next({ name: "Cart", replace: true });
      }
    },
  },
];
